// Server notices in the reader's language.
//
// A notice arrives as an English sentence and is dismissed by that exact text,
// so the TEXT stays the key and only what is shown is translated. Matched
// against the sentences the backend writes (crypto/portfolioContribution.ts and
// portfolioService.ts); anything unrecognised is shown as it came, which is the
// safe direction — an English notice beats a missing one.

const PATTERNS = [
    [/^Crypto: (\d+) wallets are not included — (.+) not configured on the server\.$/,
        (m) => ['notices.cryptoUnconfiguredMany', { count: m[1], chains: m[2] }]],
    [/^Crypto: (.+) is not included — (.+) is not configured on the server\.$/,
        (m) => ['notices.cryptoUnconfiguredOne', { name: m[1], chain: m[2] }]],
    [/^Some crypto wallets could not be read; showing their last known balances\.$/,
        () => ['notices.cryptoSomeUnreadable', {}]],
    [/^Crypto wallets could not be read; showing their last known balances\.$/,
        () => ['notices.cryptoUnreadable', {}]],
    [/^Crypto wallets are not included: they are valued in USD and the book is in (\w+)\.$/,
        (m) => ['notices.cryptoCurrency', { ccy: m[1] }]],
];

export function translateNotice(t, text) {
    for (const [pattern, toKey] of PATTERNS) {
        const m = pattern.exec(text);
        if (m) {
            const [key, vars] = toKey(m);
            return t(key, vars);
        }
    }
    return text;
}
